export default "/assets/images/spring-air-slide-sm.2fe236883d3e8a23.jpg";